

const Welcome = ()=>{
return(
    <div className="wel">
        Hello there 
    </div>
)
}

export default Welcome